<script>
import dayjs from "dayjs";
import http from "../http";
import { mapGetters } from "vuex";
import FBarDate from "@/components/FBarDate";
import FTable from "@/components/FDataInterator";

export default {
  name: "FPageSalesProducts",
  components: { FBarDate, FTable },

  data: () => ({
    products: null,
    total: null,
    updatedAt: null,
    selectedDate: Date.now(),
    type: null,
  }),

  mounted() {
    this.type = this.$route.query.as;

    this.getProductsList(Date.now());
  },

  methods: {
    async getProductsList(date) {
      const id = this.companySelected.id;
      const uri = `venda/produtos/${id}/${this.time_range(date)}`;

      try {
        const raw = (await http.get(uri, {
          clearCacheEntry:
            navigator.onLine && this.compareDates(Date.now(), date),
        })).data;

        const products = raw.data.map((p) => {
          const descricao = p.descricaoGrupoProduto || p.descricaoProduto;

          const valor = p.valorVendido.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: "currency",
            currency: "BRL",
          });

          return {
            title: descricao,
            fields: {
              valor,
              quantidade: p.quantidadeVendida,
            },
            _fields: {
              valor: p.valorVendido,
              quantidade: p.quantidadeVendida,
            },
          };
        });

        if (this.compareDates(date, this.selectedDate)) {
          this.products = products;

          if (products && products.length > 0) {
            const sumTotal = products.reduce(
              (acc, cur) => [
                cur._fields.valor + acc[0],
                cur._fields.quantidade + acc[1],
              ],
              [0, 0]
            );

            this.total = [
              sumTotal[0].toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                style: "currency",
                currency: "BRL",
              }),
              sumTotal[1],
            ];
          }

          this.updatedAt =
            this.type === "day"
              ? dayjs(raw.lastSale)
                  .add(3, "hours")
                  .valueOf()
              : null;
        }
      } catch (e) {
        this.products = null;
        this.updatedAt = null;
        this.total = null;

        console.log(e);
      }
    },

    compareDates(ts1, ts2) {
      return (
        new Date(ts1).toLocaleDateString() ===
        new Date(ts2).toLocaleDateString()
      );
    },

    time_range(ts) {
      if (this.type === "month") {
        return `${dayjs(ts)
          .startOf("month")
          .toISOString()}/${dayjs(ts)
          .endOf("month")
          .toISOString()}`;
      }

      const _base = new Date(ts);

      const base = [_base.getFullYear(), _base.getMonth() + 1, _base.getDate()];

      const base_date = base
        .map((i) => i.toString().padStart(2, "0"))
        .join("-");

      return `${base_date}T00:00:00.000Z/${base_date}T23:59:59.000Z`;
    },

    handleDateChange(date) {
      this.selectedDate = date;

      this.getProductsList(date);
    },
  },

  computed: {
    ...mapGetters(["companySelected"]),
  },
};
</script>

<template>
  <section>
    <FBarDate
      @change="this.handleDateChange"
      :lastUpdate="updatedAt"
      :type="this.type"
    />

    <FTable
      v-if="products"
      :items="products || []"
      :total="total"
      style="margin-top: 10px"
    />
  </section>
</template>
